import React from 'react'

import NotificationDetailContent from 'components/Notifications/NotificationDetailContent'
import NotificationDetailSkeleton from 'components/Notifications/NotificationDetailSkeleton'
import NotificationState from 'components/Notifications/NotificationState'
import useController from './controller'
import { DetailSurface, Page } from './styled'

export default function NotificationDetails() {
    const {
        notification,
        loading,
        loaded,
        error,
        retry,
        goBack,
        goToAction,
        goToNotifications,
        t,
    } = useController()

    return (
        <Page>
            <DetailSurface>
                {!loaded || (loading && !notification) ? (
                    <NotificationDetailSkeleton label={t('loading_notification')} />
                ) : error && !notification ? (
                    <NotificationState
                        actionLabel={t('try_again')}
                        description={t('notifications_load_error_description')}
                        onAction={retry}
                        title={t('notifications_load_error')}
                    />
                ) : notification ? (
                    <NotificationDetailContent
                        backLabel={t('back_to_notifications')}
                        notification={notification}
                        onBack={goBack}
                        onGoToAction={goToAction}
                        openLabel={t('open_notification')}
                    />
                ) : (
                    <NotificationState
                        actionLabel={t('back_to_notifications')}
                        description={t('notification_not_found_description')}
                        onAction={goToNotifications}
                        title={t('notification_not_found')}
                    />
                )}
            </DetailSurface>
        </Page>
    )
}
